import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import {Button} from 'antd'
import Start from './Start'
import End from './End'
import Capital from './Capital'
import Commission from './Commission'

import style from './style.sass'

@withRouter
@inject('store') @observer
class Controls extends Component {
  state = {
    inputLength: 0,
    selectionStart: 0
  }
  updateAndRun = () => {
    this.props.store.backtest.updateAndRun()
  }
  runBacktest = () => {
    this.props.store.backtest.run()
  }
  interruptBacktest = () => {
    this.props.store.backtest.interrupt()
  }
  render() {
    const {search} = this.props.history.location
    const tab = search ? search.match(/tab=([^&]*)/)[1] : 'total'
    const {backtest, algo} = this.props.store
    const {data} = backtest.single
    const {submitEnabled} = algo.single
    return(
      <div styleName='wrapper'>
        <Start/>
        <End/>
        <Capital tab={tab}/>
        <Commission/>
        {data?.is_currently_running
          ? <Button
            type='danger'
            onClick={this.interruptBacktest}
            loading={backtest.interrupting}
            size='large'
          >
            Interrupt Backtest
          </Button>
          : <Button
            type='primary'
            icon='thunderbolt'
            onClick={backtest.editingAlgo ? this.updateAndRun : this.runBacktest}
            disabled={data.is_currently_running || (backtest.editingAlgo && !submitEnabled)}
            size='large'
            styleName='btn-run'
          >
            Run Backtest
          </Button>
        }
      </div>
    )
  }
}

export default Controls
